var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Design-Guideline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guideline_Icons",
    transform: "translate(-892.000000, -313.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Basic-/-Line-/-Filter",
    transform: "translate(892.000000, 313.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9542226,5.95436137 L16.9542226,5.95436137 L11.9442226,12.2305265 L6.9542226,5.95436137 Z M4.2042226,6.05514192 C6.2242226,8.44591115 9.9542226,12.8766804 9.9542226,12.8766804 L9.9542226,18.4151419 C9.9542226,18.9228342 10.4042226,19.3382188 10.9542226,19.3382188 L12.9542226,19.3382188 C13.5042226,19.3382188 13.9542226,18.9228342 13.9542226,18.4151419 L13.9542226,12.8766804 C13.9542226,12.8766804 17.6742226,8.44591115 19.6942226,6.05514192 C20.2042226,5.44591115 19.77249,4 18.94249,4 L5.03248999,4 C4.20248999,4 3.6942226,5.44591115 4.2042226,6.05514192 Z",
    id: "Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.75e6fd4280be5ee13c55cc708d4431aa.svg";
export { ForwardRef as ReactComponent };